import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import * as Api from 'api';
import * as Actions from 'actions';
import { connect } from 'react-redux';

class RelationshipView extends React.Component {
  constructor(props) {
    super(props);
    this.fetchEntity = this.fetchEntity.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.fetchEntity();
  }
  state = {
    entity: null
  }
  fetchEntity() {
    const apiCall = Api[`fetch${this.props.entity_ref}`];
    if(apiCall && this.props.value) {
      this.setState({ loading: true });
      apiCall(this.props.value)
        .then(entity => this.setState({ [this.props.entity_ref] : entity }))
        .catch(error => this.setState({ error }))
        .then(e => this.setState({ loading: false }));
    }
  }
  handleClick(e) {
    e.preventDefault();
    if(this.props.value) {
      switch (this.props.entity_ref) {
        default:
          return this.props.push(`${this.props.entity_ref.toLowerCase()}/${this.props.value}`);
      }
    }
  }
  render() {
    const disabled = (this.props.disabled || !this.props.name || !this.props.entity_ref || false);
    const { loading } = this.state;

    if(loading) {
      return <div><i className="fa fa-spinner fa-spin"></i> Loading {this.props.entity_ref}...</div>
    }

    const entity = this.state[this.props.entity_ref];
    if(!entity) {
      return null;
    }

    switch(this.props.entity_ref) {
      case 'Client':
        return <a href={`${this.props.entity_ref.toLowerCase()}/${this.props.value}`} onClick={this.handleClick}><i className="fa fa-link"></i> {entity? entity.name || '(no name)' : null}<span className="text-muted"> ({this.props.entity_ref})</span></a>
      default:
        return null;
    }
  }
}

export default connect(() => ({}), Actions)(RelationshipView);



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/relationship-view.js